<h2 mat-dialog-title>{{ data.header }}</h2>

<ng-scrollbar mat-dialog-content [autoHeightDisabled]="false">
  <div class="scroll-bar-margin">
    <ng-container
      *ngTemplateOutlet="
        data.template;
        context: { $implicit: clickClose, isSaving: isSaving }
      "
    ></ng-container>
    @if (data.content) {
      <p [innerHTML]="data.content | safeHtml"></p>
    }
  </div>
</ng-scrollbar>

<div aria-live="polite" class="cdk-visually-hidden">
  @if (isSaving) {
    Saving
  }
</div>

@if (!data.hideButtonBar) {
  <div mat-dialog-actions>
    <ng-container
      *ngTemplateOutlet="
        data.extraButtons;
        context: { $implicit: clickClose, isSaving: isSaving }
      "
    ></ng-container>
    @if (primaryButtonVariant === 'flat') {
      <button
        (click)="clickClose(true)"
        mat-flat-button
        [color]="primaryColor"
        [disabled]="data.form?.invalid || isSaving"
      >
        <ng-container *ngTemplateOutlet="affirmativeLabel"></ng-container>
      </button>
    }
    @if (primaryButtonVariant === 'stroked') {
      <button
        (click)="clickClose(true)"
        mat-stroked-button
        [color]="primaryColor"
        [disabled]="isSaving"
      >
        <ng-container *ngTemplateOutlet="affirmativeLabel"></ng-container>
      </button>
    }
    @if (primaryButtonVariant === 'basic') {
      <button
        (click)="clickClose(true)"
        mat-button
        [color]="primaryColor"
        [disabled]="isSaving"
      >
        <ng-container *ngTemplateOutlet="affirmativeLabel"></ng-container>
      </button>
    }
    @if (data.noText) {
      <button
        mat-stroked-button
        (click)="clickClose(false)"
        [disabled]="isSaving"
      >
        {{ data.noText }}
      </button>
    }
  </div>
}

<ng-template #affirmativeLabel>
  <span class="affirmative-label">
    @if (isSaving) {
      <mat-spinner
        class="affirmative-spinner"
        diameter="18"
        strokeWidth="2"
        aria-hidden="true"
      ></mat-spinner>
    }
    {{ data.yesText }}
  </span>
</ng-template>
